
import CreateDetailLayout from '@/layout/edit_layout.vue'
import CoverUpload from '@/components/cover_upload/index.vue'
import Editor from '@/components/editor/index.vue'
import UploadImg from '@/common/class/UploadImg'
import { WinpressModule } from '@/store/modules/winpress'
import { Component, Vue } from 'vue-property-decorator'
import { ElForm } from 'element-ui/types/form'
import { isString } from 'lodash'
import { IMG_HOST } from '@/config/env'
import { WinpressService } from '@/services'
import { Article } from '@/common/storage'

@Component({
    name: '',
    components: {
        CreateDetailLayout,
        CoverUpload,
        Editor
    }
})
export default class extends Vue {
    private isLoading = false
    private typesLoading = true
    private articleForm = {
        title: '',
        type_id: '',
        url: '',
        abstract: '',
        content: '',
        cover_img: '',
        writer: '',
        published_at: ''
    }
    private rules = {
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        type_id: [{ required: true, message: '请选择分类', trigger: 'blur' }],
        published_at: [{ required: true, message: '请选择发表时间', trigger: 'blur' }],
        content: [{ required: true, validator: this.contentValidator }]
    }
    get articleTypes() {
        return WinpressModule.articleTypes
    }

    created() {
        this.$title('创建文章 | 麦媒云 - 庖丁')
    }
    mounted() {
        this.getArticleTypes()
    }
    async getArticleTypes() {
        await WinpressModule.getArticleTypes()
        this.initTypeId()
        this.typesLoading = false
    }
    initTypeId() {
        const matchItem = this.articleTypes.find(n => String(n.id) === this.$route.params.id)
        if (matchItem == null) {
            this.articleForm.type_id = this.articleTypes[0].id
        } else {
            this.articleForm.type_id = matchItem.id
        }
    }
    contentValidator(rule: any, value: any, callback: Function) {
        if (!this.articleForm.content) {
            callback(new Error('请输入内容'))
        }
        callback()
    }
    onContentChange(value: string) {
        this.articleForm.content = value
    }
    onSubmit() {
        (this.$refs.articleForm as ElForm).validate(async isValid => {
            if (!isValid) return
            this.isLoading = true
            const imgFile = (this.$refs.coverUpload as any).getFile()
            if (isString(imgFile)) {
                this.articleForm.cover_img = imgFile
            } else {
                const result = await new UploadImg(imgFile).upload()
                if (result.error) {
                    this.isLoading = false
                    return this.$merror('封面图上传失败，请稍后再试')
                }
                this.articleForm.cover_img = IMG_HOST + result.key
            }
            await this.createArticle()
            this.isLoading = false
        })
    }
    async createArticle() {
        const params = { ...this.articleForm }
        const result = await WinpressService.createArticle(params)
        if (result.status === 200) {
            (this.$refs.coverUpload as any).reset()
            ;(this.$refs.articleForm as ElForm).resetFields()
            this.initTypeId()
            return this.$msuccess('创建成功')
        }
        this.$merror(result.message || '发生错误, 请稍后再试')
    }
    // 预览文章
    onPreviewArticle() {
        Article.set(this.articleForm.content)
        window.open('/preview/rich-text')
    }
}
